import { useState, useEffect } from 'react';

const safeWindow = typeof window === 'undefined' ? null : window;
export default function useKeyPress(targetKeys: string[]): Record<string, boolean> {
  const [keyPressed, setKeyPressed] = useState<Record<string, boolean>>(
    targetKeys.reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {})
  );

  const handleClick = (e: KeyboardEvent, state: boolean) => {
    const lowerCaseKeys = targetKeys.map(targetKey => targetKey.toLowerCase());
    const index = lowerCaseKeys.findIndex(lowerCaseKey => lowerCaseKey === e.key.toLowerCase());
    if (index > -1) {
      setKeyPressed({ ...keyPressed, [targetKeys[index]]: state });
    }
  };

  const downHandler = (e: KeyboardEvent) => handleClick(e, true);

  const upHandler = (e: KeyboardEvent) => handleClick(e, false);

  useEffect(() => {
    safeWindow?.addEventListener('keydown', downHandler);
    safeWindow?.addEventListener('keyup', upHandler);
    return () => {
      safeWindow?.removeEventListener('keydown', downHandler);
      safeWindow?.removeEventListener('keyup', upHandler);
    };
  }, []);
  return keyPressed;
}
